import { useEffect, useRef, useState } from "react";
import { getCountdown, type Countdown } from "./utils/date";

type CellProps = {
  value: number;
  label: string;
  pad: number;
  emphasized?: boolean;
};

function Cell({ value, label, pad, emphasized }: CellProps) {
  const [flip, setFlip] = useState(false);
  const prev = useRef(value);
  useEffect(() => {
    if (prev.current !== value) {
      setFlip(true);
      const t = window.setTimeout(() => setFlip(false), 600);
      prev.current = value;
      return () => window.clearTimeout(t);
    }
  }, [value]);

  const text = String(Math.max(0, value)).padStart(pad, "0");
  return (
    <div
      className={`timer-cell${emphasized ? " is-days" : ""}${flip ? " flip" : ""}`}
    >
      <div className="timer-value">{text}</div>
      <div className="timer-label">{label}</div>
    </div>
  );
}

type Props = {
  onReached?: () => void;
};

export function Timer({ onReached }: Props) {
  const [c, setC] = useState<Countdown>(() => getCountdown());

  useEffect(() => {
    const tick = () => setC(getCountdown());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    if (c.totalMs <= 0) onReached?.();
  }, [c.totalMs, onReached]);

  return (
    <div className="timer" role="timer" aria-live="polite">
      <Cell value={c.days} label="days" pad={3} emphasized />
      <Cell value={c.hours} label="hours" pad={2} />
      <Cell value={c.minutes} label="minutes" pad={2} />
      <Cell value={c.seconds} label="seconds" pad={2} />
    </div>
  );
}
